module.exports = __webpack_public_path__ + "img/home_bg_new.ccda899.png";